import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-dropdown-accordion',
    templateUrl: './dropdown-accordion.component.html',
    styleUrl: './dropdown-accordion.component.css',
    standalone: false,
})
export class DropdownAccordionComponent implements OnInit {
    @Input() header: string = '';
    @Input() hasBulkEdit: boolean = false;
    @Input() isEditing: boolean = false;
    @Input() isInitialOpen: boolean = true;
    @Input() isPortsTable: boolean = false;
    @Input() showEditIcon: boolean = false;
    @Output() onBulkEditChange: EventEmitter<boolean> = new EventEmitter();
    @Output() onDeleteCeuUnit: EventEmitter<void> = new EventEmitter();
    @Output() onEditCeuUnit: EventEmitter<void> = new EventEmitter();

    isOpen: boolean;
    optionsVisible: boolean;

    @HostListener('document:click', [])
    clickOut() {
        this.optionsVisible = null;
    }

    constructor() {}

    ngOnInit(): void {
        this.isOpen = this.isInitialOpen;
    }

    openOptions() {
        this.optionsVisible = !this.optionsVisible;
    }
}
